const getSearchParams = (str) => {
  const res = {};
  str.replace(/([^&=]*)=([^&=]*)/g, (text, $1, $2) => {
    res[$1] = $2;
    return "0";
  });
  return res;
};

const anoyFunction = (call) => call();

const doAtOneMinute = (call, timeout) => {
  let itv = 0;
  return (...args) => {
    clearTimeout(itv);
    itv = setTimeout(() => {
      call && call(...args);
    }, timeout);
  };
};

const scrollToTop = ($container, targetTop) => {
  $container.scrollTo({ top: targetTop, behavior: "smooth" });
};

const scrollEventWithMenu = (call, $container) => {
  $container.addEventListen("scroll", () => {
    getViewportTitle(call, $container);
  });
};

const getViewportTitle = (call, $container) => {
  const $sectionSites = $container.getElementsByClassName("tender-site-title");
  let className = "";
  for (let i = 0; i < $sectionSites.length; i++) {
    const $sectionSite = $sectionSites[i];
    if ($sectionSite.offsetTop <= $container.scrollTop + 100) {
      className = $sectionSite.classList[1];
    }
  }
  call(className);
};

const readyToSetFormItemDefault = (form, options) => {
  return new Promise((resolve, reject) => {
    if (form[options.Key] === undefined) {
      resolve();
    } else {
      reject();
    }
  });
};

const copy = (obj) => JSON.parse(JSON.stringify(obj));

const isNumber = (obj) => typeof obj === "number";

export default {
  getSearchParams,
  anoyFunction,
  doAtOneMinute,
  scrollToTop,
  scrollEventWithMenu,
  getViewportTitle,
  readyToSetFormItemDefault,
  copy,
  isNumber,
};
